var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: _vm.cols,
            "form-context": _vm.formContext,
            icon: "inticon-autoclaim_lawyer",
            title: "Rechtliche Informationen",
          },
          on: { save: _vm.saveFirmAccounting },
        },
        [
          _c("h2", [_vm._v("Impressumsangaben")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Umsatzsteueridentifikationsnummer",
                  property: "taxIdentificationNumber",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Steuernummer",
                  property: "taxNumber",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Versicherungsnummer",
                  property: "insuranceNumber",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Händlernummer",
                  property: "dealerNumber",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Handelsregisternummer",
                  property: "tradeRegisterNumber",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Handelsregistersitz",
                  property: "tradeRegisterPlace",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Firmensitz",
                  property: "firmPlace",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Rechtsdienstleistungsregister",
                  property: "legalServiceRegister",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Vertretungsberechtigte",
                  property: "legalRepresentatives",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Gesellschafter",
                  property: "shareholder",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Vorstand",
                  property: "executive",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Vorstandsvorsitzender",
                  property: "chairmanExecutive",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Aufsichtsratsvorsitzender",
                  property: "chairmanSupervisory",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Individuelles Firmendetail (Signatur)",
                  property: "individualDetail",
                  type: "autogrowtextarea",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.formContext.permissions.canEditBilling
            ? _c(
                "div",
                [
                  _c("hr"),
                  _vm._v(" "),
                  _c("h2", [_vm._v("Abrechnung")]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Firmennummer",
                          property: "firmNumber",
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Adressnummer",
                          property: "addressNumber",
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Personenkonto",
                          property: "personalAccount",
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Rechnungsempfänger E-Mail",
                          property: "accountingEmail",
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Kostenstelle",
                          property: "costCentre",
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Fußtext",
                          property: "footerText",
                          type: "textarea",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          "hide-label": true,
                          label: "Manuelle Nachbearbeitung Rechnung",
                          property: "invoiceNeedsManualAdjustment",
                          type: "checkbox",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Deckelung AH Haftpflichtgebühr / Monat",
                          property: "monthlyFeeCap",
                          type: "number",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Besonderheiten Abrechnung",
                          property: "billingModalityRemarks",
                          type: "autogrowtextarea",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }